module.exports = __webpack_public_path__ + "static/media/qualitat_region_2.18eb6f64.png";